/*
 * Copyright (c) 2023 Bluemate B.V.
 */
import './style/maintenance.scss';

import React, {useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {getMaintenanceMode, setMaintenanceLoggedIn} from '../../util/maintenanceUtil';

import {ErrorType, navigate} from '@dvrd/dvr-controls';

import {BluemateButton, BluematePasswordInput} from '../controls';

import Image from '../misc/image';

import {DASHBOARD_ROUTE} from '../../util/constants';

export default function Maintenance() {
    const {t} = useTranslation();
    const [password, setPassword] = useState('');
    const [inputVisible, setInputVisible] = useState(false);
    const [error, setError] = useState<ErrorType>(null);

    function onDoubleClick(evt: React.MouseEvent) {
        evt.preventDefault();
        setInputVisible(true);
    }

    function onSubmit() {
        // It's no problem to put the password in the code as it is simply a maintenance page.
        if (password === 'YWo_3Je6jfJ*RCkGnCcJ*YkT') {
            setMaintenanceLoggedIn(true);
            navigate(DASHBOARD_ROUTE);
        } else setError(t('maintenance.invalidPassword', 'Ongeldig wachtwoord'));
    }

    function onChange(value: string) {
        setPassword(value);
        setError(null);
    }

    function onClickWeb() {
        window.location.href = 'https://bluemate.nl';
    }

    useEffect(() => {
        if (!getMaintenanceMode()) navigate(DASHBOARD_ROUTE);
    }, []);

    return (
        <div className='maintenance'>
            <Image name='logo' className='logo' onDoubleClick={onDoubleClick} />
            <h1>{t('maintenance.title', 'Onderhoud')}</h1>
            <p className='message'>
                {t(
                    'maintenance.message',
                    'Bluemate wordt momenteel bijgewerkt naar de nieuwste versie, u kunt daarom tijdelijk geen gebruik maken van Bluemate. We doen ons best om de update zo spoedig mogelijk uit te voeren. Excuses voor het ongemak.'
                )}
            </p>
            <BluemateButton onClick={onClickWeb} label={t('maintenance.backToWebsite', 'Terug naar de website')} />
            {inputVisible && (
                <BluematePasswordInput
                    onChange={onChange}
                    value={password}
                    label={t('maintenance.password', 'Wachtwoord')}
                    inputProps={{placeholder: t('maintenance.password', 'Wachtwoord')}}
                    onEnter={onSubmit}
                    className='pass-field'
                    error={error}
                    autoFocus
                    onFocus={() => {
                        setError(null);
                    }}
                />
            )}
        </div>
    );
}
